const SaakhSetuLoader = ({ message = "Loading...", size = "md" }) => {
  const sizes = {
    sm: { img: 48, text: "text-xs" },
    md: { img: 72, text: "text-sm" },
    lg: { img: 96, text: "text-base" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className="flex flex-col items-center justify-center gap-3" data-testid="saakhsetu-loader">
      <img
        src="/saakhsetu-loader.webp"
        alt="Loading"
        style={{ width: s.img, height: s.img, objectFit: "contain" }}
      />
      {message && (
        <span className={`${s.text} text-gray-500 font-medium`} style={{ fontFamily: "Inter, sans-serif" }}>
          {message}
        </span>
      )}
    </div>
  );
};

export default SaakhSetuLoader;
